import { validateFieldsArrayForFinalForm } from '@framework/ui/Organisms/FinalForm/validators/validateFieldsArrayForFinalForm';
import { validateEmail } from '@framework/ui/Organisms/FinalForm/validators/user/validateEmail';
import { validateDuplicate } from '@framework/ui/Organisms/FinalForm/validators/validateDuplicate';
import { validateMaxLength } from '@framework/ui/Organisms/FinalForm/validators/validateMaxLength';
import { validateMinLength } from '@framework/ui/Organisms/FinalForm/validators/validateMinLength';
import { validateRequiredField } from '@framework/ui/Organisms/FinalForm/validators/validateRequiredField';
import { ISpeakerArrayItem } from '@evercall/domain/vo/call/SpeakerArrayItem';

const requiredSpeakerEmail = (param) => {
  if (!param.allValue.email || param.allFieldsValue.collection.length === 1) {
    return validateRequiredField(param);
  }
  return null;
};

const requiredSpeakerName = (param) => {
  if (!param.allValue.name) {
    return validateRequiredField(param);
  }
  return null;
};

const paramsSpeakers = [
  {
    fieldName: 'email',
    fieldCaption: 'Email',
    functionValidation: [
      {
        name: requiredSpeakerEmail,
        params: {},
      },
      {
        name: validateEmail,
        params: {},
      },
      {
        name: validateDuplicate,
        params: {
          listName: 'Speakers',
        },
      },
    ],
  },
  {
    fieldName: 'name',
    fieldCaption: 'Speaker Name',
    functionValidation: [
      {
        name: requiredSpeakerName,
        params: {},
      },
      {
        name: validateMaxLength,
        params: { length: 128 },
      },
      {
        name: validateMinLength,
        params: { length: 3 },
      },
    ],
  },
];

export const validateSpeakers = (speakersValue: ISpeakerArrayItem[] = []) => validateFieldsArrayForFinalForm(
  'speakers',
  paramsSpeakers,
  { collection: speakersValue },
);
